import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions } from "@reporting/rp-app-host";
import { AccessLogEntity } from "@reporting/rp-types/accounting";

const PAGE_SIZE = 500;

export class AccessLogGridAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(
		private idGroup: number = null
	) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'group_name',
			header: msg('Group'),
			t: 't',
			w: 150,
		}, {
			data: 'user_name',
			header: '#',
			t: 't',
			w: 150,
		}, {
			data: 'login_name',
			header: msg('User'),
			t: 't',
			w: 150,
		}, {
			data: 'email',
			header: msg('Email'),
			t: 't',
			w: 150,
		}, {
			data: 'action',
			header: msg('Actions'),
			t: 't',
			w: 150,
		}, {
			data: 'result',
			header: msg('Result'),
			t: 't',
			w: 200,
		}, {
			data: 'date_created',
			header: msg('Date'),
			t: 'dt',
			w: 145,
		}, {
			data: 'ip',
			header: `IP ${msg('Address')}`,
			t: 't',
			w: 150,
		}, {
			data: 'host',
			header: msg('Host'),
			t: 't',
			w: 150,
		}, {
			data: 'server',
			header: msg('Server'),
			t: 't',
			w: 65,
			hidden: !!this.idGroup
		}, {
			data: 'user_agent',
			header: msg('User Agent'),
			t: 't',
			w: 400,
		}, {
			data: 'remark',
			header: msg('Text'),
			t: 't',
			w: 200,
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const logs = await rp.ms('accounting').get<AccessLogEntity[]>(`accessLog${this.idGroup ? `/${this.idGroup}` : ''}`, this.createRequestParams(filters, {
			count: PAGE_SIZE,
		}));
		return logs.map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			editable: false,
			lightTheme: null,
			darkTheme: null,
			toolbar: {
				autoUpdate: {enabled: true},
				save: {enabled: false},
				discard: {enabled: false},
				new: {enabled: false},
			},
		});
	}

}
